import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'openDemoProjectEditor',
  'translateYourVideoClick',
  'translateYourVideoEditorDemoClick',
  'upgradeApplyChangesEditorDemoClick',
  'onboardingFinishedEditorDemo',
  'upgradePlanAccountPageDemo',
  'dashboardOpenTrial',
  'trialProjectOpen',
  'trialProcessingScreenView',
  'upgradeVoiceCloneAccountClick',
  'downloadButtonClick',
  'videoOptionDownloadClick',
  'videoWithSubtitlesOptionDownloadClick',
  'videoWithLipsyncOptionDownloadClick',
  'audioOptionDownloadClick',
  'srtOptionDownloadClick',
  'upgradeToTranslateFullPlayerClick',
  'applyChangesTrialProjectClick',
  'trialPreviewWhatNextItemClick',
  'trialFeatureUpsellModalShown',
  'trialFeatureUpsellModalUnlockClick',
  'trialPricingModalShown',
  'trialPricingModalDismissed',
  'trialPricingModalContinueWithFreeTrialClick',
  'trialPricingModalBookDemoClick',
  'trialPricingModalSwitchAnnual',
  'trialPricingModalSwitchMonthly',
  'trialPricingModalPlanGetStartedClick',
  'trialPreviewUnlockFullAccessClick',
  'trialPreviewExportClick',
  'trialExportPaywallShown',
  'trialExportPaywallUnlockClick',
  'trialExportPaywallShareClick',
  'trialProcessingEmailConsentClick',
  'mobileEditorNoticeShown',
  'trialActivated',
] as const;

// Fired while the page may be hiding or unloading, so they skip the SDK batch queue.
const TRIAL_PROCESSING_PRESENCE_EVENTS = [
  'trialProcessingScreenLeft',
  'trialProcessingScreenReturned',
  'trialProcessingScreenCompleted',
] as const;

export const demoProjectsTrial = [
  ...getMappedEvents([...EVENTS], {
    shouldSendSubscriptionData: true,
  }),
  ...getMappedEvents([...TRIAL_PROCESSING_PRESENCE_EVENTS], {
    shouldSendImmediately: true,
    shouldSendSubscriptionData: true,
  }),
];
